import React, { useState, useEffect, useCallback } from 'react';
import { DatePicker, Button, Table, Progress, Tag, message } from 'antd';
import { getTeachersReport } from '../../api/reports';
import { numberSorter, textSorter } from '../../utils/tableSorters';

const { RangePicker } = DatePicker;

const TeachersReportTab = () => {
  const [range, setRange] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const params = range
        ? { start_date: range[0].format('YYYY-MM-DD'), end_date: range[1].format('YYYY-MM-DD') }
        : {};
      const res = await getTeachersReport(params);
      setData(res.data);
    } catch {
      message.error('Öğretmen raporu yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }, [range]);

  useEffect(() => { fetch(); }, []);

  // Liste tamamen bellekte (sunucu sayfalamasi yok), bu yuzden istemci
  // siralayicilari dogru sonuc verir. Sayisal kolonlarda numberSorter sart:
  // varsayilan siralama metin gibi karsilastirip 100 < 25 < 5 yapardi.
  const columns = [
    {
      title: 'Öğretmen',
      dataIndex: 'name',
      sorter: textSorter('name'),
    },
    {
      title: 'Rol',
      dataIndex: 'role',
      sorter: textSorter('role'),
      render: v => v === 'branch_manager' ? <Tag color="orange">Şube Müdürü</Tag> : <Tag color="blue">Öğretmen</Tag>,
    },
    { title: 'Şube', dataIndex: 'branch', sorter: textSorter('branch'), render: v => v || '—' },
    {
      title: 'Toplam Ders',
      dataIndex: 'total_sessions',
      align: 'center',
      sorter: numberSorter('total_sessions'),
    },
    {
      title: 'Toplam Kayıt (Gelen+Gelmeyen)',
      dataIndex: 'total_attendances',
      align: 'center',
      sorter: numberSorter('total_attendances'),
    },
    {
      title: 'Gelen',
      dataIndex: 'present_count',
      align: 'center',
      sorter: numberSorter('present_count'),
      render: v => <span className="text-green-600">{v}</span>,
    },
    {
      title: 'Devam Oranı',
      dataIndex: 'attendance_rate',
      align: 'center',
      sorter: numberSorter('attendance_rate'),
      render: v => (
        <div className="flex items-center gap-2">
          <Progress
            percent={v}
            size="small"
            style={{ width: 80, marginBottom: 0 }}
            strokeColor={v >= 80 ? '#52c41a' : '#faad14'}
          />
          <span className="text-xs">{v}%</span>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <RangePicker
          value={range}
          onChange={setRange}
          format="DD.MM.YYYY"
          placeholder={['Başlangıç (opsiyonel)', 'Bitiş']}
        />
        <Button type="primary" onClick={fetch} loading={loading}>Getir</Button>
        {range && <Button onClick={() => setRange(null)}>Tüm Zamanlar</Button>}
      </div>

      <Table
        dataSource={data || []}
        rowKey="id"
        columns={columns}
        size="small"
        loading={loading}
        pagination={{ pageSize: 20 }}
      />
    </div>
  );
};

export default TeachersReportTab;
